export const grid = {
  colCount: 12,
  gap: {
    min: 20,
    max: 24,
  },
}
